import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingCartIcon, TruckIcon, XIcon } from 'lucide-react';
import { CartLineItem } from './CartLineItem';
import { useCart } from '../../contexts/CartContext';
import { formatPrice } from '../../utils/currency';
export function CartDrawer() {
  const {
    items,
    isOpen,
    closeCart,
    subtotal,
    count
  } = useCart();
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && closeCart();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, closeCart]);
  return <AnimatePresence data-id="element-19" data-mp="22yzvx5tla5ja">
      {isOpen && <>
          <motion.div key="overlay" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: 'easeOut'
      }} onClick={closeCart} className="fixed inset-0 z-50 bg-ink/40" aria-hidden="true" data-id="element-20" data-mp="22wdod66p7q12" />
          <motion.aside key="drawer" role="dialog" aria-modal="true" aria-label="Winkelwagen" initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        duration: 0.28,
        ease: [0.32, 0.72, 0, 1]
      }} className="fixed right-0 top-0 z-50 flex h-full w-full max-w-md flex-col bg-white" data-id="element-21" data-mp="3k3zymvfeju68">
            <div className="flex h-16 items-center justify-between border-b border-line px-5" data-id="element-22" data-mp="6vx15q1xosz1">
              <h2 className="text-base font-bold text-ink" data-id="element-23" data-mp="3o4jyw7v9vdwl">
                Winkelwagen <span className="font-medium text-muted" data-id="element-24" data-mp="3t3wsdbgnfj85">({count})</span>
              </h2>
              <button type="button" onClick={closeCart} aria-label="Winkelwagen sluiten" className="flex h-9 w-9 items-center justify-center rounded-lg text-ink hover:bg-surface" data-id="element-25" data-mp="2cpokmn0jfegk">
                <XIcon className="h-5 w-5" data-id="element-26" data-mp="o8n1mfj6zso2" />
              </button>
            </div>

            {items.length === 0 ? <div className="flex flex-1 flex-col items-center justify-center px-8 text-center" data-id="element-27" data-mp="egr16xtmvqgo">
                <ShoppingCartIcon className="h-10 w-10 text-ink/20" aria-hidden="true" data-id="element-28" data-mp="9hnvdb5txg7n" />
                <p className="mt-4 text-base font-semibold text-ink" data-id="element-29" data-mp="9ftkkpo9v4ha">Je winkelwagen is leeg</p>
                <p className="mt-1 text-sm text-muted" data-id="element-30" data-mp="4g8b3lbh7dqb">Bekijk onze bestsellers of gebruik het batterijadvies.</p>
                <Link to="/shop" onClick={closeCart} className="mt-6 inline-flex h-11 items-center rounded-lg bg-ink px-5 text-sm font-semibold text-white hover:bg-ink-soft" data-id="element-31" data-mp="3rn9bwzr14d0k">
                  Begin met winkelen
                </Link>
              </div> : <>
                <div className="flex items-center gap-2 bg-surface px-5 py-3 text-xs font-medium text-ink" data-id="element-32" data-mp="1kxcn0fu133es">
                  <TruckIcon className="h-4 w-4 text-success" aria-hidden="true" data-id="element-33" data-mp="1sg2doq5289or" />
                  Gratis verzending · Binnen 1–2 werkdagen in huis
                </div>
                <ul className="flex-1 divide-y divide-line overflow-y-auto px-5" data-id="element-34" data-mp="227ggp7w7zrmn">
                  {items.map(item => <CartLineItem key={item.key} item={item} onNavigate={closeCart} data-id="element-35" data-mp="274gl7edf8mbn" />)}
                </ul>
                <div className="border-t border-line p-5" data-id="element-36" data-mp="1egkuqreg3qnb">
                  <div className="flex items-baseline justify-between" data-id="element-37" data-mp="1eh2wg3jvmx2m">
                    <span className="text-base font-semibold text-ink" data-id="element-38" data-mp="1jfe4q9uiwziq">Subtotaal</span>
                    <span className="text-xl font-bold tracking-tight text-ink" data-id="element-39" data-mp="1ofa2hrcmnupu">{formatPrice(subtotal)}</span>
                  </div>
                  <p className="mt-1 text-xs text-muted" data-id="element-40" data-mp="2uuaz7z9h8gxh">
                    Incl. btw · of 3 × {formatPrice(Math.round(subtotal / 3 * 100) / 100)} met Klarna
                  </p>
                  <Link to="/cart" onClick={closeCart} className="mt-4 flex h-12 w-full items-center justify-center rounded-lg bg-volt text-sm font-bold text-ink transition-colors duration-150 hover:bg-volt-hover" data-id="element-41" data-mp="2xga9tm8perm1">
                    Verder naar afrekenen
                  </Link>
                  <button type="button" onClick={closeCart} className="mt-2 h-10 w-full text-sm font-medium text-ink hover:underline" data-id="element-42" data-mp="3ge3b6k3oithb">
                    Verder winkelen
                  </button>
                </div>
              </>}
          </motion.aside>
        </>}
    </AnimatePresence>;
}